async function fetchSitemapUrls(sitemapUrl) {
  try {
    const res = await fetch(sitemapUrl);
    const text = await res.text();
    console.log(text);

    const parser = new DOMParser();
    const xml = parser.parseFromString(text, "application/xml");

    // Try to get <url><loc>...</loc></url> structure
    const locElements = Array.from(xml.getElementsByTagName("loc"));
    const urls = locElements.map((el) => el.textContent);

    return urls;
  } catch (err) {
    console.error("Failed to fetch sitemap:", err);
    return [];
  }
}

export default fetchSitemapUrls;
